import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMouseScrollUp: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconMouseScrollUp"><Path fillRule="evenodd" clipRule="evenodd" d="M8.72265 5.3867L12 3.2018L15.2774 5.3867L16.3868 3.7226L12 0.798096L7.61325 3.7226L8.72265 5.3867Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M6 11.9999C6 8.68624 8.68629 5.99995 12 5.99995C15.3137 5.99995 18 8.68624 18 11.9999V16.9999C18 20.3137 15.3137 22.9999 12 22.9999C8.68629 22.9999 6 20.3137 6 16.9999V11.9999ZM13 9.99995H11V13.9999H13V9.99995Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMouseScrollUp;
